<div class="header">
  <div class="al-page-title">
    <a
      *ngIf="lesson"
      class="al-page-back al-relief-icon al-relief-icon--large al-icon--chevron-left"
      [routerLink]="['/academy/topics', lesson.topic]"
      [attr.aria-label]="'academy.backToTopic' | translate"
      [nbTooltip]="'academy.backToTopic' | translate"
      nbTooltipPlacement="right"
    ><span class="al-relief-glyph" aria-hidden="true"></span></a>
    <h2>{{ title }}</h2>
  </div>
  <!-- Zwei Ebenen tief: ← zum Thema, ✕ zur Academy-Startseite (design.md §5 „Zurück und Schließen“) -->
  <a
    class="al-page-close al-relief-icon al-relief-icon--large al-icon--close"
    routerLink="/academy"
    [attr.aria-label]="'academy.backToAcademy' | translate"
    [nbTooltip]="'academy.backToAcademy' | translate"
    nbTooltipPlacement="left"
  ><span class="al-relief-glyph" aria-hidden="true"></span></a>
</div>

<app-page-loader *ngIf="!ready"></app-page-loader>

<div class="lesson-layout" *ngIf="ready && lesson">
  <nb-card class="lesson-main">
    <nb-card-body>
      <!-- 1 Warum: ein Satz aus Sicht der Rolle (Lektionsmuster). -->
      <p class="lesson-why" *ngIf="why">{{ why }}</p>

      <!-- Vorschau: kurzer Film im Loop — derselbe wie im Portalhinweis. -->
      <app-academy-video
        alAnchor="academy.lesson-video"
        [video]="lesson.video"
        [seconds]="lesson.videoSeconds"
        [captions]="captions"
        [label]="title"
      ></app-academy-video>

      <div class="lesson-badges">
        <span class="academy-chip academy-chip--success" *ngIf="status === 'completed'">
          <nb-icon icon="checkmark-outline"></nb-icon>
          {{ 'academy.status.completed' | translate }}
        </span>
        <span class="academy-chip academy-chip--hint" *ngIf="lesson.hintId">
          <nb-icon icon="bulb-outline"></nb-icon>
          {{ 'academy.badge.hintLesson' | translate }}
        </span>
        <span class="academy-chip academy-chip--muted" *ngIf="lesson.bloom">
          {{ 'academy.bloom.' + lesson.bloom | translate }}
        </span>
      </div>

      <p class="lesson-requires" *ngIf="requires.length">
        {{ 'academy.lesson.requires' | translate }}
        <ng-container *ngFor="let r of requires; let last = last">
          <a [routerLink]="['/academy/lessons', r.lesson.id]">{{ r.title }}</a>
          <nb-icon *ngIf="r.status === 'completed'" class="lesson-requires__done" icon="checkmark-outline"></nb-icon>{{ last ? '' : ', ' }}
        </ng-container>
      </p>

      <!-- Selbst machen — der Kern der Lektion: nach der kurzen Vorschau führt
           der Klickpfad durchs echte Portal, die Prüfung liest den echten
           Zustand. Gespeichert wird nur durch die Person (Marcel, 29.10.2026). -->
      <section class="tile-flat lesson-do lesson-do--lead" *ngIf="tourSteps.length || lesson.doneCheck" alAnchor="academy.try-in-portal">
        <header class="tile-flat__header">
          <h5>{{ 'academy.lesson.doIt' | translate }}</h5>
        </header>
        <p class="lesson-do__text" *ngIf="tourSteps.length">
          {{ 'academy.lesson.doItText' | translate: { n: tourSteps.length } }}
        </p>
        <div class="lesson-do__actions">
          <button *ngIf="tourSteps.length" nbButton status="primary" type="button" (click)="startTour()">
            <nb-icon icon="navigation-2-outline"></nb-icon>
            {{ 'academy.lesson.startTour' | translate }}
          </button>
          <ng-container [ngSwitch]="doneState">
            <span *ngSwitchCase="'checking'" class="lesson-do__state">
              <nb-icon icon="loader-outline" class="al-spin"></nb-icon>
              {{ 'academy.lesson.checking' | translate }}
            </span>
            <span *ngSwitchCase="'done'" class="academy-chip academy-chip--success lesson-do__chip">
              <nb-icon icon="checkmark-outline"></nb-icon>
              {{ 'academy.lesson.doneInPortal' | translate }}
            </span>
            <span *ngSwitchCase="'open'" class="lesson-do__state">
              {{ 'academy.lesson.notDoneYet' | translate }}
              <button type="button" class="lesson-do__recheck" (click)="checkDone()">
                {{ 'academy.lesson.recheck' | translate }}
              </button>
            </span>
          </ng-container>
        </div>
      </section>

      <section class="tile-flat">
        <header class="tile-flat__header">
          <h5>{{ 'academy.lesson.summary' | translate }}</h5>
        </header>
        <p class="lesson-summary">{{ summary }}</p>
        <ul class="lesson-points" *ngIf="points.length">
          <li *ngFor="let p of points">
            <nb-icon icon="checkmark-circle-2-outline"></nb-icon>
            <span>{{ p }}</span>
          </li>
        </ul>
      </section>

      <section class="tile-flat" id="lesson-quiz" *ngIf="questions.length" alAnchor="academy.lesson-quiz">
        <header class="tile-flat__header">
          <h5>{{ 'academy.lesson.quiz' | translate }}</h5>
        </header>
        <app-academy-quiz [questions]="questions" mode="practice" (completed)="onQuizCompleted($event)"></app-academy-quiz>
        <p class="lesson-quiz-done" *ngIf="quizResult" role="status">
          {{ 'academy.lesson.quizDone' | translate: { correct: quizResult.correct, total: quizResult.total } }}
        </p>
      </section>
    </nb-card-body>

    <nb-card-footer class="lesson-actions" id="lesson-actions">
      <button
        *ngIf="lesson.target && !tourSteps.length"
        nbButton
        appearance="outline"
        status="primary"
        type="button"
        alAnchor="academy.try-in-portal"
        (click)="tryInPortal()"
      >
        <nb-icon icon="external-link-outline"></nb-icon>
        {{ 'academy.lesson.tryInPortal' | translate }}
      </button>
      <span class="lesson-actions__spacer"></span>
      <button
        *ngIf="!questions.length && status !== 'completed' && !next"
        nbButton
        status="primary"
        type="button"
        (click)="complete()"
      >
        {{ 'academy.lesson.complete' | translate }}
      </button>
      <button *ngIf="next || status === 'completed'" nbButton status="primary" type="button" (click)="goNext()">
        {{
          (next
            ? !questions.length && status !== 'completed'
              ? 'academy.lesson.completeAndNext'
              : 'academy.lesson.next'
            : 'academy.lesson.backToAcademy'
          ) | translate
        }}
        <nb-icon icon="arrow-forward-outline"></nb-icon>
      </button>
    </nb-card-footer>
  </nb-card>

  <nb-card class="lesson-side">
    <nb-card-header>
      <h6>{{ topicTitle }}</h6>
    </nb-card-header>
    <nb-card-body>
      <nb-list>
        <nb-list-item *ngFor="let r of side; let i = index; trackBy: trackSide" [class.selected]="r.lesson.id === lesson.id">
          <app-academy-lesson-item
            [lesson]="r.lesson"
            [title]="r.title"
            [status]="r.status"
            [index]="i"
            [current]="r.lesson.id === lesson.id"
            [compact]="true"
          ></app-academy-lesson-item>
        </nb-list-item>
      </nb-list>
    </nb-card-body>
  </nb-card>
</div>
